"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export function ScrollToHash() {
  const router = useRouter();

  useEffect(() => {
    // Get the hash from the URL
    const hash = window.location.hash;
    if (hash) {
      // Remove the '#' symbol
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        // JS scrolling isn't covered by the global reduced-motion CSS rule.
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
        element.scrollIntoView({
          behavior: reduce.matches ? "auto" : "smooth",
        });
      }
    }
  }, [router]);

  return null;
}
